/**
 * NewLogin actions
 */

import * as constants from './constants';

export const loginV2 = ({ body }) => ({
  type: constants.LOGIN_V2_REQUEST,
  body,
});

export const ssoLoginV2 = () => ({
  type: constants.SSO_LOGIN_V2_REQUEST,
});

export const checkSsoDomain = (email) => ({
  type: constants.CHECK_SSO_DOMAIN_REQUEST,
  email,
});

export const showPasswordField = () => ({
  type: constants.SHOW_PASSWORD_FIELD,
});

export const validateOTP = ({ body }) => ({
  type: constants.VALIDATE_OTP_REQUEST,
  body,
});

export const resendOTP = ({ onSuccess } = {}) => ({
  type: constants.RESEND_OTP_REQUEST,
  onSuccess,
});

export const forgotPassword = ({ body }) => ({
  type: constants.FORGOT_PASSWORD_REQUEST,
  body,
});

export const setPassword = ({ body }) => ({
  type: constants.SET_PASSWORD_REQUEST,
  body,
});

export const clearError = () => ({
  type: constants.CLEAR_ERROR,
});

export const resetPasswordField = () => ({
  type: constants.RESET_PASSWORD_FIELD,
});

export const checkOtpSession = () => ({
  type: constants.OTP_SESSION_CHECK_REQUEST,
});

export const logoutV2 = () => ({
  type: constants.LOGOUT_V2_REQUEST,
});
